import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelpDeskRoutingModule } from './help-desk-routing.module';
import { HelpDeskComponent } from './help-desk.component';
import { CardyHelpDeskModule } from '@pics-module/help-desk';

@NgModule({
  declarations: [HelpDeskComponent],
  imports: [CommonModule, HelpDeskRoutingModule, CardyHelpDeskModule]
})
export class HelpDeskModule {}
